'use es6';

import { addPreProcessTransform, addPostProcessTransform } from '../../../utils/transformer';
import { getSingleInnerMostLeaf } from '../../../utils/dom';
import { hsSanitizeAllow } from '../../../constants/hscore';
const NBSP = '&nbsp;';

// Pad the innermost empty node of DIVs with NBSP instead of using the flawed
// valid_elements schema which will pad DIVs even if they have children (who are empty)
function initPaddingPlugin(editor) {
  const padEmptyRootDivs = dom => {
    const nodes = dom.querySelectorAll('div');
    Array.from(nodes).forEach(node => {
      const leaf = getSingleInnerMostLeaf(node);
      if (leaf && leaf.nodeType === 1 && leaf.nodeName !== 'IFRAME' && !leaf.closest(`[${hsSanitizeAllow}]`)) {
        leaf.innerHTML = NBSP;
      }
    });
  };
  addPreProcessTransform(editor, padEmptyRootDivs);
  addPostProcessTransform(editor, padEmptyRootDivs);
}
export default initPaddingPlugin;